import StoreTable from './StoreTable'

export default StoreTable
